import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Field"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "field"
    }}>{`Field`}</h1>
    <p>{`Wrapper around primitive form control components`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Field } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Field label="Email" name="email" defaultValue="" />
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Component`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`form control to render, default `}<inlineCode parentName="td">{`Input`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`label`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text for `}<inlineCode parentName="td">{`Label`}</inlineCode>{` component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Used for the `}<inlineCode parentName="td">{`for`}</inlineCode>{`, `}<inlineCode parentName="td">{`id`}</inlineCode>{`, and `}<inlineCode parentName="td">{`name`}</inlineCode>{` attributes`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`All other props are passed directly to the form control.`}</p>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`Field`}</inlineCode>{` component uses the same variants as the other `}<a parentName="p" {...{
        "href": "/components/forms"
      }}>{`form components`}</a>{` that it is composed of.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      